import { Dropdown, DropdownProps } from '@eduact/ed-components'
import { useCallback } from 'react'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { Translation, useTranslation } from 'react-i18next'

type Props<T extends FieldValues> = {
	control: Control<T>
	name: Path<T>
	localeName?: string
	values?: { key: string; value: string | number; localeKey: string }[]
} & DropdownProps

const CustomDropdown = <T extends {}>({ control, name, placeholder, ref, children, localeName, onChange, values, ...props }: Props<T>) => {
	const [t] = useTranslation('inputs', { useSuspense: false })

	const getChildren = useCallback(() => {
		if (!values) return children
		return values.map(item => (
			<Dropdown.Option value={item.value} key={item.key}>
				<Translation ns="dropdowns">{t => t(item.localeKey)}</Translation>
			</Dropdown.Option>
		))
	}, [children, values])
	return (
		<Controller
			control={control}
			name={name}
			render={({ field: { value, onChange: onControllerChange, ...others }, fieldState }) => {
				return (
					<Dropdown
						error={fieldState.error ? true : false}
						helperText={fieldState.error ? t(`validations.${fieldState.error.message}`, { field: t(localeName ?? name) }) : ''}
						placeholder={t(placeholder ?? '')}
						value={value as any}
						onChange={(e: any) => {
							onChange?.(e)
							onControllerChange(e)
						}}
						{...others}
						{...props}
					>
						{getChildren()}
					</Dropdown>
				)
			}}
		/>
	)
}

export default CustomDropdown
